module.exports = __webpack_public_path__ + "img/软件产品证书-门禁报警系统V1.0.84f6d735.jpg";